import type { Fx } from "@shared/types";

// A one-line pub/sub so the socket layer can hand celebration events to
// whichever component wants to render them, without threading a callback
// through every page. Fx are fire-and-forget: missing one is never a bug.

type Listener = (fx: Fx) => void;
const listeners = new Set<Listener>();

export function emitFx(fx: Fx): void {
  for (const l of [...listeners]) {
    try {
      l(fx);
    } catch {
      /* a broken listener must not stop the others */
    }
  }
}

export function subscribeFx(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
